<h2 mat-dialog-title>Logs</h2>
<p class="subtitle">{{ data.subTitle }}</p>
<mat-dialog-content>
  <form [formGroup]="form">
    <app-input-field
      label="Type"
      formControlName="type"
      type="select"
      [options]="logTypes"
    ></app-input-field>

    <app-input-field
      label="Lines count"
      formControlName="lines"
      type="select"
      [options]="logLines"
    ></app-input-field>
  </form>
</mat-dialog-content>
<mat-dialog-actions>
  <button matButton="filled" (click)="submit()" [disabled]="form.invalid">Request Logs</button>
  <button matButton="elevated" (click)="close()">Close</button>
</mat-dialog-actions>
